// extracted by mini-css-extract-plugin
export var sliderRange = "_n7-2";
export var sliderRoot = "_n7-0";
export var sliderThumb = "_n7-3";
export var sliderTrack = "_n7-1";